const { AstraBookingFilter } = require("./lib/AstraBookingFilter");
const { AstraBookingHandler } = require("./lib/AstraBookingHandler");

// Initialize the filter logic once the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    new AstraBookingFilter();
    new AstraBookingHandler();
});